import { load, save } from './storageProvider/storage';

export interface ConsumptionInfo {
  consumedCount: number;
  firstConsumedAt: number | null;
}

const initializeInfo = (): ConsumptionInfo => ({
  consumedCount: 0,
  firstConsumedAt: null,
});

export class FilmQuotaStorageProvider {
  constructor(
    public namespace: string = 'vs-fqs',
  ) {}

  async getConsumptionInfo(): Promise<ConsumptionInfo> {
    return load(this.namespace) ?? initializeInfo();
  }

  async consume(count = 1): Promise<ConsumptionInfo> {
    const info = await this.getConsumptionInfo();
    if (info.firstConsumedAt == null) {
      info.firstConsumedAt = Date.now();
    }

    info.consumedCount += count;
    save(this.namespace, info);

    return this.getConsumptionInfo();
  }

  async reset(): Promise<ConsumptionInfo> {
    const info = initializeInfo();
    save(this.namespace, info);

    return this.getConsumptionInfo();
  }
}
